import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelUserEntity } from '../../domain/entities/ChannelUserEntity'

export class ChannelUserModel extends ChannelUserEntity {
  constructor(dataDto: ChannelUserEntity) {
    super()
    mapEntityProperties<ChannelUserModel>(this, dataDto)
  }
}
